<template>
  <div>

    <div class="row">
      <div class="col-md-12">

        <div class="card">

          <div class="card-header">
            Listado de amigos
            <div class="card-actions">
              <button class="btn btn-primary" v-b-tooltip.hover title="Volver al inicio" @click="Inicio()" >
                <i class="icon-arrow-left"></i>
              </button>
              <button class="btn btn-success" v-b-tooltip.hover title="Agregar amigo" @click="agregarAmigo()" >
                <i class="icon-plus"></i>
              </button>
            </div>
          </div>

          <div class="card-body">

            <b-alert show variant="info" v-if="procesando == true">
              <b-progress height="20px" :max="100" variant="info" striped :animated="true">
                <b-progress-bar :value="100" :label="'&lt;strong&gt;Procesando...&lt;/strong&gt;'">
                </b-progress-bar>
              </b-progress>
            </b-alert>

            <b-alert show class="text-center" variant="danger" v-if="procesando == false && error == true">
              {{mensaje_error}}
            </b-alert>

            <div v-if="procesando == false">

              <b-row>
                <b-col sm="3">
                  <b-form-group>
                    <label for="campo_busqueda">Opción de búsqueda</label>
                    <select class="form-control" name="campo_busqueda" :disabled="procesando" v-model="estado_pagina.campo_busqueda" @change="cambioOpcionCampoBusqueda()">
                      <option value="">Seleccione una opción</option>
                      <option v-for="campo in opciones_formulario.campos_busqueda" v-bind:value="campo.nombre">
                        {{ campo.titulo }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col sm="5">
                  <b-form-group>
                    <label for="criterio_busqueda">Criterio búsqueda</label>
                    <b-form-input type="text" name="criterio_busqueda" :disabled="procesando || estado_pagina.campo_busqueda === ''" v-model="estado_pagina.criterio_busqueda" placeholder="Ingrese el criterio de búsqueda"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group>
                    <label for="registros_por_pagina">Registros por página</label>
                    <select class="form-control" name="registros_por_pagina" :disabled="procesando" v-model="estado_pagina.registros_por_pagina">
                      <option v-for="registros in opciones_formulario.registros_por_pagina" v-bind:value="registros">
                        {{ registros }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col sm="1">
                  <label for="buscar">&nbsp;</label>
                  <br />
                  <button class="btn btn-pill btn-primary" v-b-tooltip.hover title="Buscar" @click="seleccionarPagina (1)">
                    <i class="icon-magnifier"></i>
                  </button>
                </b-col>
              </b-row>

              <hr />

              <table class="table table-responsive-sm table-hover table-outline mb-0" v-if="usuarios.length > 0">
              <thead class="bg-info">
                <tr>
                  <th class="text-center">
                    <i class="fa fa-hashtag"></i>
                  </th>
                  <th>Nombre completo</th>
                  <th class="text-center">Estado</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(usuario, index) in usuarios" :key="usuario.codigo" :index="index">
                  <td class="text-center">
                    <span>{{ (pagination.current_page - 1) * (pagination.per_page) + (index + 1) }}</span>
                  </td>
                  <td>
                    <span>{{usuario.primer_nombre}}</span>
                    <span v-if="usuario.segundo_nombre">{{usuario.segundo_nombre}}</span>
                    <span>{{usuario.primer_apellido}}</span>
                    <span v-if="usuario.segundo_apellido">{{usuario.segundo_apellido}}</span>
                  </td>
                  <td class="text-center">
                    <span v-if="usuario.activo == true">Activo</span>
                    <span v-else>Inactivo</span>
                  </td>
                  <td class="text-center">
                    <button class="btn btn-pill btn-warning" v-b-tooltip.hover title="Editar registro" @click="editarUsuario(usuario)" >
                      <i class="icon-pencil"></i>
                    </button>
                    <button :id="'botonEliminar' + (index + 1)" @click="mostrarAccionEliminar = !mostrarAccionEliminar" class="btn btn-pill btn-danger" v-b-tooltip.hover title="Eliminar registro">
                      <i class="icon-trash"></i>
                    </button>

                    <b-popover :ref="'botonEliminar'" :target="'botonEliminar' + (index + 1)" :show.sync="mostrarAccionEliminar">
                      <template slot="title">¿Está seguro de eliminar el registro?</template>
                      <div class="text-center">
                        <button class="btn btn-pill btn-success" v-b-tooltip.hover title="Aceptar" @click="eliminarUsuario(usuario.codigo)" >
                          <i class="icon-check"></i>
                          Aceptar
                        </button>
                        <button class="btn btn-pill btn-danger" v-b-tooltip.hover title="Cancelar" @click="cancelarEliminarUsuario(index)" >
                          <i class="icon-close"></i>
                          Cancelar
                        </button>
                      </div>
                    </b-popover>

                  </td>
                </tr>
              </tbody>
            </table>

              <b-alert show variant="secondary"  v-if="usuarios.length > 0">
                Mostrando {{pagination.count}} registros del {{ (pagination.current_page - 1) * (pagination.per_page) + 1 }} al {{ (pagination.current_page - 1) * (pagination.per_page) + pagination.count }} de un total de {{pagination.total}} registros existentes.
                <div class="pull-right">Página {{pagination.current_page}} de {{pagination.total_pages}}.</div>
              </b-alert>

              <hr v-if="usuarios.length > 0"/>

              <div class="text-center" v-if="usuarios.length > 0">
                <div class="d-inline-block">
                  <div class="btn-toolbar mx-auto" role="toolbar" aria-label="Paginación" v-if="pagination.total_pages > 0">
                    <div class="btn-group mr-2" role="group" aria-label="Anterior" v-if="pagination.links.previous">
                      <button type="button" class="btn btn-outline-info" @click="seleccionarPagina(1)">
                        <i class="fa fa-angle-double-left fa-lg"></i>
                      </button>
                      <button type="button" class="btn btn-outline-info" @click="seleccionarPagina(pagination.current_page - 1)">
                        <i class="fa fa-angle-left fa-lg"></i>
                      </button>
                    </div>
                    <div class="btn-group mr-2" role="group" aria-label="Páginas">
                      <button type="button" disabled class="btn btn-outline-secondary" v-if="pagination.current_page > 3">
                        <i class="icon-options"></i>
                      </button>
                      <button type="button" class="btn btn-outline-info" v-if="((pagination.current_page - (index + 1)) < 3) && (((index + 1) - pagination.current_page) < 3)" v-for="(pagina, index) in pagination.total_pages" :index="index" :class="{active: (index + 1) === pagination.current_page }" @click="seleccionarPagina(index + 1)">{{index + 1}}</button>
                      <button type="button" disabled class="btn btn-outline-secondary"  v-if="pagination.current_page < pagination.total_pages - 2">
                        <i class="icon-options"></i>
                      </button>
                    </div>
                    <div class="btn-group" role="group" aria-label="Siguiente" v-if="pagination.links.next">
                      <button type="button" class="btn btn-outline-info" @click="seleccionarPagina(pagination.current_page + 1)">
                        <i class="fa fa-angle-right fa-lg"></i>
                      </button>
                      <button type="button" class="btn btn-outline-info" @click="seleccionarPagina(pagination.total_pages)">
                        <i class="fa fa-angle-double-right fa-lg"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <b-alert show class="text-center" variant="warning" v-if="usuarios.length == 0">
                No hay registros.
              </b-alert>

            </div>

          </div>
        </div>
      </div>
      <!--/.col-->

    </div>
    <!--/.row-->

  </div>
</template>

<script>
import router from '@/router/index.js'
import usuario from '@/js/usuario.js'

export default {
  name: 'listado-amigos',
  mounted () {
    let cargarPagina = true

    if (cargarPagina) {
      this.procesando = false
      this.error = false

      if (sessionStorage.getItem('estado_paginas')) {
        if (JSON.parse(sessionStorage.getItem('estado_paginas')).listado_usuarios) {
          this.estado_pagina = JSON.parse(sessionStorage.getItem('estado_paginas')).listado_usuarios
        }
      }

      this.seleccionarPagina(this.estado_pagina.pagina)
    }
  },
  data () {
    return {
      procesando: true,
      error: false,
      mensaje_error: 'Se ha presentado un error en el sistema. Por favor intente más tarde. Si el error continua por favor comuníquese con el administrador del sistema.',
      mostrarAccionEliminar: false,
      entidad: {},
      usuarios: [],
      opciones_formulario: {
        campos_busqueda: [
          {'nombre': 'primer_nombre', 'titulo': 'Primer nombre'},
          {'nombre': 'segundo_nombre', 'titulo': 'Segundo nombre'},
          {'nombre': 'primer_apellido', 'titulo': 'Primer apellido'},
          {'nombre': 'segundo_apellido', 'titulo': 'Segundo apellido'},
          {'nombre': 'correo_electronico', 'titulo': 'Correo electrónico'}
        ],
        registros_por_pagina: [
          '5',
          '10',
          '20',
          '30',
          '40',
          '50'
        ]
      },
      pagination: {},
      estado_paginas: {},
      estado_pagina: {
        pagina: 1,
        campo_busqueda: '',
        criterio_busqueda: '',
        registros_por_pagina: 20
      }
    }
  },
  methods: {
    listarUsuarios () {
      this.procesando = true
      this.error = false

      usuario.pagina = this.estado_pagina.pagina

      if (this.estado_pagina.campo_busqueda === '') {
        usuario.campo_busqueda = this.opciones_formulario.campos_busqueda[0].nombre
        usuario.criterio_busqueda = ''
      } else {
        usuario.campo_busqueda = this.estado_pagina.campo_busqueda
        usuario.criterio_busqueda = this.estado_pagina.criterio_busqueda
      }
      usuario.registros_por_pagina = this.estado_pagina.registros_por_pagina

      usuario.getListadoUsuarios().then(response => {
        if (response.status === 'success') {
          this.procesando = false
          this.error = false

          this.usuarios = response.data

          if (response.meta) {
            this.pagination = response.meta.pagination
          }
        } else {
          this.procesando = false
          this.error = true
          // console.log(response)
        }
      })
    },
    seleccionarPagina (pagina) {
      this.estado_pagina.pagina = pagina

      if (sessionStorage.getItem('estado_paginas')) {
        this.estado_paginas = JSON.parse(sessionStorage.getItem('estado_paginas'))
      }

      if (this.estado_paginas.listado_usuarios === undefined) {
        this.estado_paginas['listado_usuarios'] = this.estado_pagina
      } else {
        this.estado_paginas.listado_usuarios = this.estado_pagina
      }

      sessionStorage.setItem('estado_paginas', JSON.stringify(this.estado_paginas))
      this.listarUsuarios()
    },
    cambioOpcionCampoBusqueda () {
      if (this.estado_pagina.campo_busqueda === '') {
        this.estado_pagina.criterio_busqueda = ''
      }
    },
    agregarAmigo () {
      router.push({
        name: 'gestion-usuarios-crear-usuario'
      })
    },
    editarUsuario (usuario) {
      sessionStorage.setItem('datos_usuario', JSON.stringify(usuario))
      router.push({
        name: 'gestion-usuarios-editar-usuario'
      })
    },
    cancelarEliminarUsuario (indice) {
      this.$refs.botonEliminar[indice].$emit('close')
    },
    eliminarUsuario (codigo) {
      this.procesando = true
      this.error = false

      usuario.codigo_usuario = codigo
      usuario.deleteUsuario().then(response => {
        if (response.status === 'success') {
          this.procesando = false
          this.error = false

          this.usuario = response.data
          this.listarUsuarios()
        } else {
          this.procesando = false
          this.error = true
          // console.log(response)
        }
      })
    },
    Inicio () {
      router.push({
        name: 'home'
      })
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/Comunidad/Amigo/Listar.vue